<section class="admin-portfolio-list-section">
    <header class="row page-header">
        <div class="col-sm-6 d-flex align-items-center">
          <h2 class="title">PORTFOLIOS</h2>
        </div>
        <div class="col-sm-6 d-flex align-items-center justify-content-end">
            <button type="button" class="btn btn-toggle btn-toggle-no-shadow" title="Add new portfolio" (click)="addPortfolio.show()">
                <i aria-hidden="true" class="fa fa-plus fa-1x"></i>
                Add new portfolio
            </button>
        </div>
    </header>
      

    <main>
        <sp-admin-add-portfolio #addPortfolio></sp-admin-add-portfolio>
        <sp-admin-portfolio-list
            [portfolioFilterSettings]="portfolioFilterSettings$ | async"
            [workspaces]="workspaces$ | async"
            (deactivate)="onDeactivatePortfolio($event)"
            (reactivate)="onReactivatePortfolio($event)"
            (filterChanged)="onFilterChanged($event)" 
        ></sp-admin-portfolio-list>
    </main>
</section>
